import { useCallback } from 'react';
import {
  useLocation,
  unstable_useBlocker as useBlocker,
} from 'react-router-dom';

const usePathnameBlocker = (
  paths: string[],
  handleExit: (val: boolean) => void,
  allowNavigation?: boolean
) => {
  const { pathname } = useLocation();

  const blockerFunction = useCallback(
    ({ nextLocation }: any) => {
      if (
        allowNavigation ||
        paths.some((path) => nextLocation.pathname.includes(path))
      ) {
        return false;
      }
      handleExit(true);
      return true;
    },
    [pathname, allowNavigation]
  );

  const blocker = useBlocker(blockerFunction);

  const proceedWithNavigation = () => {
    if (blocker && blocker.proceed) {
      blocker.proceed();
      handleExit(false);
    }
  };

  return proceedWithNavigation;
};

export default usePathnameBlocker;
